import Navbar from "../Navbar/Navbar";

const Header = () => {
  return (
    <header className="header">
      <Navbar />
    </header>
  );
};

export default Header;
